import {BusinessProcess} from '../filter/businessProcess.model';

export class BusinessProcessDimension {
  id: number;
  businessProcessId: number;
  name: string;
  version: number;
}

export class BusinessProcessDimensionListResult {
  error: boolean;
  errorMessage: string;
  errorMessageDetails: string;
  result: Array<BusinessProcessDimension>;
}
